import ajax from "./ajax";

export const listByPage = params => ajax(`/rotation/listByPage`, params,'POST');
export const insert = params => ajax(`/rotation/insert`, params,'POST');
export const update = params => ajax(`/rotation/update`, params,'POST');
export const del = params => ajax(`/rotation/delete`, params,'POST');
export const querySingle = params => ajax(`/rotation/querySingle`, params,'POST');
// -----------------------------


// //登录

// export const login = params => ajax(`/system/login`, params,'POST');
// //
// export const userList = params => ajax(`/user/list`, params,'POST');
// //用户分页查询

// export const listByPage = params => ajax(`/user/listByPage`, params,'POST');
// //新增用户
// export const insertUser = params => ajax(`/user/insert`, params,'POST');
// //删除用户
// export const deleteUser = params => ajax(`/user/delete`, params,'POST');

// //禁用用户  
// export const disableUser = params => ajax(`/user/disable`, params,'POST');

// //启用用户  
// export const enableUser = params => ajax(`/user/enable`, params,'POST');

// //根据ID查询用户   /user/listByIds
// export const listByIds = params => ajax(`/user/listByIds`, params,'POST');

// //修改用户信息
// export const updateUser = params => ajax(`/user/update`, params,'POST');

// //日志查询

// export const listByPageLog = params => ajax(`/log/listByPage`, params,'POST');

// //用户重置密码

// export const resetPassword = params => ajax(`/user/resetPassword`, params,'POST');


// ------------------


























